import { appendQueryString } from "../appendQueryString";
import type { Api } from "./api.types";

const energyDataApiWithoutCamelization = {
  warnings: {
    url: ({ variantId }: { variantId: number }) =>
      appendQueryString("api/energy-data-warnings/", { variant_id: variantId }),
    key: ({ variantId }: { variantId: number }) => [
      "energy-data-warnings",
      { variant_id: variantId }
    ]
  }
} satisfies Api;

export { energyDataApiWithoutCamelization };
